import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsDisplayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_display"}/>
}
